(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorano-home-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async (event) => {
  const link = event.target.closest('.vorano-home-footer-wrap [data-vh-cookie-preferences]');
  if (!link || !window.privacyBanner?.showPreferences) return;
  event.preventDefault();
  try { await window.privacyBanner.showPreferences(); }
  catch { window.location.assign(link.href); }
});

document.addEventListener('click', (event) => {
  const openLink = event.target.closest('.vorano-home-footer-wrap [data-vh-legal-open]');
  if (openLink) {
    const dialog = document.getElementById('vhLegalGuaranteeDialog');
    if (dialog?.showModal) { event.preventDefault(); dialog.showModal(); }
    return;
  }
  const closeButton = event.target.closest('[data-vh-legal-close]');
  const dialog = document.getElementById('vhLegalGuaranteeDialog');
  if (closeButton && dialog?.open) dialog.close();
  if (dialog?.open && event.target === dialog) dialog.close();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorano-home-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click", (event) => { if (event.target.closest(".vh-mobile-menu a")) event.target.closest("details").open = false; });
document.addEventListener("keydown", (event) => { if (event.key === "Escape") document.querySelectorAll(".vh-mobile-menu[open]").forEach(menu => { menu.open = false; menu.querySelector("summary").focus(); }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorano-home-light"] && !Shopify.designMode) return;
  try {
    
function voranoLightInit(root) { root.querySelectorAll('[data-vh-light]').forEach(section => { section.querySelector('.vh-light-off')?.setAttribute('aria-hidden','true'); }); }
voranoLightInit(document); document.addEventListener('shopify:section:load', event => voranoLightInit(event.target));
document.addEventListener('click', (event) => { const button = event.target.closest('[data-vh-light] .light-toggle'); if (!button) return; const section = button.closest('[data-vh-light]'); const on = button.getAttribute('aria-checked') !== 'true'; button.setAttribute('aria-checked',String(on)); button.querySelector('[data-vh-light-label]').textContent = on ? button.dataset.labelOn : button.dataset.labelOff; section.querySelector('.light-image').classList.toggle('off',!on); section.querySelector('.vh-light-on')?.setAttribute('aria-hidden',String(!on)); section.querySelector('.vh-light-off')?.setAttribute('aria-hidden',String(on)); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorano-home-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => { const button = event.target.closest('[data-vh-color]'); if (!button) return; const card = button.closest('[data-vh-product]'); const color = button.dataset.vhColor; card.querySelectorAll('[data-vh-color]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); card.querySelectorAll('[data-vh-color-panel]').forEach(item => item.hidden = item.dataset.vhColorPanel !== color); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorano-product"] && !Shopify.designMode) return;
  try {
    
function initVoranoProducts(){document.querySelectorAll('.vp').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const stage=root.querySelector('.stage'),main=root.querySelector('#main-photo'),lit=root.querySelector('#lit-photo'),switcher=root.querySelector('.light-switch');let light=true;const off=main.src,on=lit.src;function toggle(){stage.classList.toggle('light-off',!light);switcher.setAttribute('aria-checked',String(light));root.querySelector('#light-label').textContent=light?root.dataset.on:root.dataset.off;}switcher.onclick=()=>{light=!light;toggle()};function select(b){const studio=b.dataset.photo==='studio',detail=b.dataset.photo==='detail',switchable=studio||detail;main.src=studio?off:detail?b.dataset.off:b.dataset.photo;lit.src=detail?b.dataset.on:on;stage.classList.toggle('dimensions',!switchable);lit.hidden=!switchable;switcher.hidden=!switchable;root.querySelectorAll('[data-photo]').forEach(t=>{t.classList.toggle('selected',t===b);t.setAttribute('aria-pressed',String(t===b))});root.querySelector('.photo-count').textContent=String(Array.from(root.querySelectorAll('[data-photo]')).indexOf(b)+1).padStart(2,'0')+' / '+String(root.querySelectorAll('[data-photo]').length).padStart(2,'0');main.alt=studio?root.dataset.title:detail?root.dataset.title+' – Detailansicht von unten':root.dataset.dimensions;}root.querySelectorAll('[data-photo]').forEach(b=>b.onclick=()=>select(b));const dimensionLink=root.querySelector('.dimensions-link');if(dimensionLink)dimensionLink.onclick=()=>select(root.querySelector('[data-photo]:not([data-photo="studio"]):not([data-photo="detail"])'));const qty=root.querySelector('input[name="quantity"]');root.querySelectorAll('[data-quantity]').forEach(b=>b.onclick=()=>{b.dataset.quantity==='up'?qty.stepUp():qty.stepDown();qty.dispatchEvent(new Event('change',{bubbles:true}))});const bar=root.querySelector('.sticky-buy');const purchase=root.querySelector('#purchase');if(bar&&purchase){const observer=new IntersectionObserver(entries=>{const r=entries[0];bar.hidden=r.isIntersecting||r.boundingClientRect.top>0});observer.observe(purchase);root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});}toggle();});}initVoranoProducts();document.addEventListener('shopify:section:load',initVoranoProducts);

  } catch(e) { console.error(e); }
})();
})();
